import React, { createContext, useContext, ReactNode } from 'react';
import {
    useHiveCoreEvents,
    HiveCoreState,
    UseHiveCoreEventsOptions,
    TelemetryDebugState,
} from './useHiveCoreEvents';

interface HiveCoreContextValue {
    state: HiveCoreState;
    connected: boolean;
    sendIntent: (name: string, args?: any) => void;
    reconnect: () => void;
    disconnect: () => void;
    // Debug state for telemetry inspector (dev-only)
    telemetryDebugEnabled: boolean;
    debugState: TelemetryDebugState;
}

const HiveCoreContext = createContext<HiveCoreContextValue | null>(null);

export { HiveCoreContext };

export interface HiveCoreProviderProps extends UseHiveCoreEventsOptions {
    children: ReactNode;
}

export function HiveCoreProvider({ children, ...options }: HiveCoreProviderProps) {
    const hiveCore = useHiveCoreEvents(options);

    return <HiveCoreContext.Provider value={hiveCore}>{children}</HiveCoreContext.Provider>;
}

export function useHiveCore() {
    const context = useContext(HiveCoreContext);
    if (!context) {
        throw new Error('useHiveCore must be used within HiveCoreProvider');
    }
    return context;
}
